import type { SVGProps } from 'react';

const SvgThreadsColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.178 2H7.832C4.205 2 2.044 4.17 2.044 7.81v8.37c0 3.65 2.161 5.82 5.787 5.82h8.338c3.625 0 5.787-2.17 5.787-5.81V7.81C21.966 4.17 19.804 2 16.179 2Z'
      fill='#EFF0F3'
    />
    <path
      clipRule='evenodd'
      d='M8.676 8.127c.812-.866 1.99-1.377 3.447-1.377 2.397 0 3.986 1.381 4.49 3.295a.526.526 0 0 1-1.017.267c-.381-1.45-1.552-2.512-3.473-2.512-1.2 0-2.09.414-2.68 1.045-.597.636-.93 1.534-.93 2.564v1.182c0 1.03.333 1.928.93 2.564.59.631 1.48 1.045 2.68 1.045.869 0 1.558-.202 2.087-.528.533-.328.85-.763.94-1.262.102-.576-.024-.97-.24-1.255a1.693 1.693 0 0 0-.428-.39c-.07.394-.197.765-.388 1.056-.705 1.07-2.052 1.162-2.94.808-.481-.192-.893-.716-1.021-1.279a1.585 1.585 0 0 1 .074-.967c.139-.334.397-.619.764-.835.363-.215.903-.313 1.438-.328.322-.01.672.012 1.023.07-.073-.342-.198-.596-.338-.727-.254-.236-.675-.403-1.097-.4-.408.003-.754.16-.96.49a.524.524 0 1 1-.891-.556c.44-.702 1.163-.979 1.844-.984.667-.005 1.354.248 1.82.681.471.44.674 1.16.726 1.814.46.2.893.493 1.21.912.41.54.587 1.238.438 2.074-.152.853-.69 1.522-1.423 1.973-.718.442-1.604.683-2.638.683-1.457 0-2.635-.511-3.447-1.377-.806-.86-1.212-2.029-1.212-3.282v-1.182c0-1.253.406-2.422 1.212-3.282Zm4.804 4.24a4.38 4.38 0 0 0-1.043-.097c-.468.013-.796.101-.933.182-.202.12-.289.24-.328.335a.536.536 0 0 0-.02.33c.064.282.276.493.387.536.591.236 1.33.111 1.674-.41.123-.187.221-.503.262-.876Z'
      fill='#000'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgThreadsColor;
